// extracted by mini-css-extract-plugin
export default {"window":"Payments_window__zS5H0"};